import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12 7.125V5.5m0 1.625a1.625 1.625 0 1 0 0 3.25m0-3.25a1.625 1.625 0 1 1 0 3.25m-4.875 6.5a1.625 1.625 0 1 0 0-3.25m0 3.25a1.625 1.625 0 1 1 0-3.25m0 3.25V18.5m0-4.875V5.5M12 10.375V18.5m4.875-1.625a1.625 1.625 0 1 0 0-3.25m0 3.25a1.625 1.625 0 1 1 0-3.25m0 3.25V18.5m0-4.875V5.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render };